import { Component, OnInit } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accounts-subscribers',
  templateUrl: './accounts-subscribers.component.html',
  styleUrls: ['./accounts-subscribers.component.sass']
})
export class AccountsSubscribersComponent implements OnInit {
  public banlist: any;
  public listData: any;
  public selectBan: string;
  public inputSearch: string = '';
  public inputSearchAccount: string = '';
  public data: object;
  public filteredData = [];
  public numberSubscribers = [];
  public expand = [];
  public statusLoader: boolean = false;
  public accountType: string = '';
  public statusOn: number = 0;
  public errorCounter: number = 0;
  public notSetSearcher: boolean = false;
  public statusRadio = [false, false]
  constructor(public global: GlobalService, private services: Service, private loadingScreenService: LoadingScreenService, private router: Router) { }

  ngOnInit() { 
  }
  ngAfterContentInit() {
    this.loadData();
  }

  loadData() {
    if (this.global.sessionReview() == true) {
      this.statusLoader = true;
      this.selectBan = '';
      var ofertas = '[';
      this.loadingScreenService.startLoadingMin2();
      if (sessionStorage.getItem("listData") == null) {
        this.services.getSubscriberList("", "", sessionStorage.getItem("token"), 1, 3000).subscribe(data => {
          if (data.hasError == false) {
            sessionStorage.setItem("listData", btoa(JSON.stringify(data)));
            this.listData = data.accounts;
            for (let i = 0; i < data.accounts.length; i++) {
              if (i > 0) {
                ofertas += ',';
              }
              ofertas += '{"account":"' + data.accounts[i].account + '"}';
            }
            ofertas += ']';
            this.statusLoader = false;
            this.filterBan('', data.accounts);
            this.loadingScreenService.stopLoadingMin2();
          }
          else {
              this.global.notif(data.errorDesc);
              this.loadingScreenService.stopLoadingMin2();
          }
        });
      }
      else {
        this.listData = JSON.parse(atob(sessionStorage.getItem("listData")));
        this.filterBan('', this.listData.accounts);
        this.statusLoader = false;
      }
    }
  }
  updateExpand(index) {
    this.global.validateSession();
    this.expand[index] = !this.expand[index];
  }
  searchFilter() {
    this.filterBan('', this.listData);
  }
  filterBan(searchFor, data) {
    this.filteredData = [];
    for (let i = 0; i < data.length; i++) {
      this.numberSubscribers[i] = 0;
      for (let j = 0; j < data[i].length; j++) {
        if (data[i].account.indexOf(this.inputSearch) !== -1 || this.inputSearch == '') {
          this.numberSubscribers[i] = this.numberSubscribers[i] + 1;
        }
      }
      if (searchFor === '') {
        this.filteredData.push(data[i]);
      }
      else {
        if (searchFor === data[i].account) {
          this.filteredData.push(data[i]);
        }
      }
    }
    this.expand[0] = true;
  }
  changeType(type: number) {
    this.global.validateSession();
    this.statusOn = type;
    if (type == 1) {
      this.statusRadio[0] = true;
      this.statusRadio[1] = false;
      this.accountType = 'Movil';
    }
    else {
      this.statusRadio[0] = false;
      this.statusRadio[1] = true;
      this.accountType = 'Fijo';
    }
    this.inputSearchAccount = '';
    this.inputSearch = '';
    this.byTypeSubcriptor();
  }
  countSubcriptor() {
    this.filteredData.forEach((obj, index1) => {
      this.numberSubscribers[index1] = 0;
      obj.subscribers.forEach((obj2, index2) => {
        if (obj2.subscriber.indexOf(this.inputSearch) !== -1 || this.inputSearch == '') {
          this.numberSubscribers[index1] = this.numberSubscribers[index1] + 1;
        }
      });
    });
  }
  byTypeSubcriptor() {
    this.filteredData.forEach((obj, index1) => {
      this.numberSubscribers[index1] = 0;
      obj.subscribers.forEach((obj2, index2) => {
        if (this.accountType == this.global.checkProductType(obj2.productType) && (obj2.subscriber.indexOf(this.inputSearch) !== -1 || this.inputSearch == '')) {
          this.numberSubscribers[index1] = this.numberSubscribers[index1] + 1;
        }
      });
    });
  }

  clear() {
    this.inputSearch = '';
    this.inputSearchAccount = '';
    this.accountType = '';
    this.statusOn = 0;
    this.statusRadio[0] = false;
    this.statusRadio[1] = false;
    this.filterBan('', this.listData.accounts);
  }
  search() {
    this.statusRadio[0] = false;
    this.statusRadio[1] = false;
    this.accountType = '';
    this.statusOn = 0;
    this.filterBan(this.inputSearchAccount, this.listData.accounts);
    this.inputSearchAccount = '';
    this.inputSearch = '';
    this.numberSubscribers[0] = 1;
  }
  goSubscriberDetail(account, subscriber) {
    sessionStorage.setItem("account_B", btoa(account));
    sessionStorage.setItem("subscriber_B", btoa(subscriber));
    this.router.navigate(['subscriberdetail']);
  }
}